import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/homepage/HomePage";
import Resilience from "./components/resilience/Resilience";
import Connect from "./components/connect/Connect";
import ConcessionalFinance from "./components/resilience/archetypes/ConcessionalFinance";
import BankableProjects from "./components/resilience/archetypes/BankableProjects";
import Grants from "./components/resilience/archetypes/Grants";
import Project from "./components/project/Project";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Resilience" element={<Resilience />} />
          <Route path="/Connect" element={<Connect />} />
          <Route path="/Archetypes/Grants" element={<Grants />} />
          <Route
            path="/Archetypes/ConcessionalFinance"
            element={<ConcessionalFinance />}
          />
          <Route
            path="/Archetypes/BankableProjects"
            element={<BankableProjects />}
          />
          <Route path="/Project" element={<Project />} />
          <Route path="/Project/:searchtitle" element={<Project />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
